module.exports = __webpack_public_path__ + "static/media/logo.9def7595.svg";